export var baseFontSize = 16;
export var mobilePX = 959;
export var desktopPX = mobilePX + 1;
export var smallPX = 576;
export var mediumPX = 768;
export var largePX = 992;
export var extraLargePX = 1200;
export var mobileEM = "".concat(mobilePX / baseFontSize, "em");
export var desktopEM = "".concat(desktopPX / baseFontSize, "em");
export var smallEM = "".concat(smallPX / baseFontSize, "em");
export var mediumEM = "".concat(mediumPX / baseFontSize, "em");
export var largeEM = "".concat(largePX / baseFontSize, "em");
export var extraLargeEM = "".concat(extraLargePX / baseFontSize, "em");
export var onMobile = "@media only screen and (max-width: ".concat(mobileEM, ")");
export var onDesktop = "@media only screen and (min-width: ".concat(desktopEM, ")");
export var onSmallScreen = "@media only screen and (max-width: ".concat(smallEM, ")");
export var onMediumScreen = "@media only screen and (max-width: ".concat(mediumEM, ")");
export var onLargeScreen = "@media only screen and (max-width: ".concat(largeEM, ")");
export var onExtraLargeScreen = "@media only screen and (max-width: ".concat(extraLargeEM, ")");